const o = () => ({
  width: 20,
  height: 20,
  color: "#222",
  strokeColor: "#222",
  fillColor: "none"
});
export {
  o as g
};
